<template>
    <div class="row">
        <div class="col-12">
            <div class="form-group">
                <label for="address" class="lbl">Physical Address</label>
                <input autocomplete="chrome-off" type="text" name="address[address]" id="address" class="form-control" placeholder="" v-model="address">
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group">
                <label for="country_id" class="lbl">Country </label>
                <select name="address[country]" id="country_id" class="custom-select" v-model="country">
                    <option disabled>Select One</option>
                    <option v-for="countryItem in countries" :value="countryItem.name">
                        {{ countryItem.name }}
                    </option>
                </select>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group">
                <label for="city" class="lbl">City</label>
                <input type="text" name="address[city]" id="city" class="form-control" placeholder="" v-model="city">
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group">
                <label for="state" class="lbl">State/Province </label>
                <select name="address[state]" id="state" class="custom-select" placeholder="" v-model="state" v-if="country == 'United States'">
                    <option disabled>Select One</option>
                    <option v-for="stateItem in states" :value="stateItem.code">
                        {{ stateItem.code }}
                    </option>
                </select>
                <input type="text" name="address[state]"  class="form-control" v-else v-model="state">
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group">
                <label for="zip" class="lbl">Zip Code</label>
                <input type="text" name="address[zip]" id="zip" class="form-control" placeholder="" v-model="zip">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            countries: Array,
            states: Array,
            input_zip: '',
            input_state: '',
            input_country: '',
            input_city: '',
            input_address: '',
        },
        data() {
            return {
                zip: this.input_zip,
                state: this.input_state,
                country: this.input_country,
                city: this.input_city,
                address: this.input_address,
            }
        }
    }

</script>
